



















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import fetch from "@/common/api/fetch";

import { pickHtmlTextContent } from "@/common/utils/dealWithString";
import getUrlParam from "@/common/utils/getUrlParam";
import getActivityType from "@/common/utils/getActivityType";
import { exchangeMsgToXcx, wechatSignUp } from "@/common/utils/wechatFunc";

import {
  AxiosPromiseData,
  AxiosPromiseError,
  ShareObjectInterface,
  SignatureData
} from "@/common/interface";
import CONFIG from "@/common/config";

@Component
export default class GroupJoinFooter extends Vue {
  @Getter("section") section!: any;
  @Getter("gradientColor") gradientColor!: string;
  @Getter("uid") uid!: string;
  @Getter("urlUid") urlUid!: string;
  @Getter("qrCodeUrl") qrCodeUrl!: string;
  @Getter("openId") openId!: string;
  @Getter("title") title!: string;
  @Getter("joinNumber") joinNumber!: number;
  @Getter("signature") signature!: SignatureData;
  @Getter("coverTiny") coverTiny!: string;
  @Getter("groupFull") groupFull!: boolean;
  @Getter("showFooter") showFooter!: boolean;
  @Getter("showJoinFooter") showJoinFooter!: boolean;
  @Getter("joinGroupFlag") joinGroupFlag!: boolean;
  @Getter("canPay") canPay!: boolean;
  @Getter("payType") payType!: string;
  @Getter("payNumber") payNumber!: number;
  @Getter("hasPay") hasPay!: number;
  @Getter("startTime") startTime!: number;
  @Getter("deadline") deadline!: any;
  @Getter("orgId") orgId!: string;
  @Getter("posterName") posterName!: string;
  @Getter('courseType') courseType!: string;
  @Getter('selectedSeqNo') selectedSeqNo!: number;
  @Getter("cancel") cancel!: boolean;
  
  @Action("changeJoinNumber") changeJoinNumber!: Function;
  @Action("changeUid") changeUid!: Function;
  @Action("changeUrlUid") changeUrlUid!: Function;
  @Action("changeGroupNumber") changeGroupNumber!: Function;
  @Action("changeJoinGroupFlag") changeJoinGroupFlag!: Function;
  @Action("changePosterUrl") changePosterUrl!: Function;
  @Action("changeLeadersInstId") changeLeadersInstId!: Function;

  type: string = getUrlParam("type") as string;
  show: boolean = false;
  showJoin: boolean = false;
  originatorId: string = "";
  leadersInstId?: string;
  leaderId: string = '';
  groupFlag: boolean = true; // 当前团是否存在


  
  @Watch('urlUid')
  getCurrentGroup() {
    if (!this.urlUid) return null;
    const param = {
      activityId: getUrlParam("broadcastId"),
      userId: this.urlUid
    };
    fetch.newpost("anon/group/getCurrentGroup", param)
      .then((res: AxiosPromiseData) => {
        if (res.result) {
           const { result: { leadersInstId, leaderId } } = res;
        this.leadersInstId = leadersInstId;
          this.leaderId = leaderId;
          this.groupFlag = true;
        } else {
          this.groupFlag = false;
        }
      })
  }

  handleShowJoinModal(originatorId: string = "") {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error("活动未开始");
      return;
    }
    if (originatorId) {
      this.originatorId = originatorId;
    }
    this.changeLeadersInstId(this.leadersInstId);
    if (this.canPay) {
      // 未报名或者已经报名但是没有支付
      const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
      const host: string = location.host;
      const tempStr: string = env === "gray" ? "/xmpay" : "/xmpay";

      if (!this.uid || (this.uid && this.hasPay !== 4)) {
        // 跳转到小程序支付页面
        if (window.__wxjs_environment === "miniprogram") {
          const promoterId = getUrlParam("promoterId");
          const referralId = getUrlParam("referralId");
          const broadcastId = getUrlParam("broadcastId");
          let qrCodeUrl = this.qrCodeUrl;
          if (env === "gray") {
            qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
          }
          const scene =
            `openId=${this.openId}&activityId=${broadcastId}&originatorId=${
              this.originatorId
            }&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}` +
            (this.leadersInstId ? `&leadersInstId=${this.leadersInstId}` : "") +
            (promoterId ? `&promoterId=${promoterId}` : "") +
            (referralId ? `&referralId=${referralId}` : "") +
            (this.urlUid ? `&parentUid=${this.urlUid}` : "") +
            (this.selectedSeqNo ? `&seqNo=${this.selectedSeqNo}` : "");
          window.wx.miniProgram.navigateTo({
            url: `/pages/pay-detail/index?${scene}&joinType=true`
          });
        } else {
          fetch.post("c/common/pay/appid", {}).then((res: AxiosPromiseData) => {
            const payAppId: string = res.data;

            const targetUrl: string =
              "https://" +
              host +
              tempStr +
              (env === "prod" || env === "gray" ? "/index.html" : "/") +
              "#/xmx_group_pay?userOpenId=" +
              this.openId +
              "&broadcastId=" +
              getUrlParam("broadcastId") +
              (getUrlParam("promoterId")
                ? "&promoterId=" + getUrlParam("promoterId")
                : "") +
              (getUrlParam("referralId")
                ? "&referralId=" + getUrlParam("referralId")
                : "") +
              "&originatorId=" +
              this.originatorId +
              (this.urlUid ? "&parentUid=" + this.urlUid : "");

            const url: string =
              (CONFIG.shareUrl as any)[env] +
              payAppId +
              "&redirect_uri=" +
              encodeURIComponent(targetUrl) +
              (targetUrl.indexOf("?") != -1 ? "%26" : "%3F") +
              "appid%3D" +
              payAppId +
              "&response_type=code&scope=snsapi_base&state=state#wechat_redirect";
            location.href = url;
          });
        }
      } else {
        // 已报名,跳转到小程序支付结结果页面
        if (window.__wxjs_environment === "miniprogram") {
          const broadcastId = getUrlParam("broadcastId");
          let qrCodeUrl = this.qrCodeUrl;
          if (env === "gray") {
            qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
          }
          const scene = `openId=${
            this.openId
          }&activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(
            qrCodeUrl
          )}`;
          window.wx.miniProgram.redirectTo({
            url: `/pages/pay-result/index?${scene}`
          });
        } else {
          const targetUrl: string =
            "https://" +
            host +
            tempStr +
            (env === "prod" || env === "gray" ? "/index.html" : "/") +
            "#/xmx_group_pay_result?userOpenId=" +
            this.openId +
            "&broadcastId=" +
            getUrlParam("broadcastId");
          location.href = targetUrl;
        }
      }
    } else {
      Vue.$modal({
        ok: (
          name: string,
          phone: string,
          authCode: string,
          additionalInfo: string,
          instId?: string,
        ) => {
          this.joinOtherGroup(name, phone, authCode, additionalInfo, instId);
        }
      });
    }
  }

  handleShowOpenModal() {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error("活动未开始");
      return;
    }
    // 如果活动已过期，则弹窗
    if (new Date().valueOf() > Number(this.deadline)) {
      Vue.$confirm({
        oneBtn: true,
        title: '来晚啦',
        text: '活动已结束！',
        okText: '确定'
      });
      return;
    }
    this.changeLeadersInstId('');
    if (this.canPay) {
      // 未报名或者已经报名但是没有支付
      const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
      const host: string = location.host;
      const tempStr: string = env === "gray" ? "/xmpay" : "/xmpay";

      if (!this.uid || (this.uid && this.hasPay !== 4)) {
        // 跳转到小程序支付页面
        if (window.__wxjs_environment === "miniprogram") {
          const promoterId = getUrlParam("promoterId");
          const referralId = getUrlParam("referralId");
          const broadcastId = getUrlParam("broadcastId");
          let qrCodeUrl = this.qrCodeUrl;
          if (env === "gray") {
            qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
          }
          const scene =
            `openId=${
              this.openId
            }&activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(
              qrCodeUrl
            )}` +
            (promoterId ? `&promoterId=${promoterId}` : "") +
            (referralId ? `&referralId=${referralId}` : "") +
            (this.urlUid ? `&parentUid=${this.urlUid}` : "");

          window.wx.miniProgram.navigateTo({
            url: `/pages/pay-detail/index?${scene}`
          });
        } else {
          fetch.post("c/common/pay/appid", {}).then((res: AxiosPromiseData) => {
            const payAppId: string = res.data;

            const targetUrl: string =
              "https://" +
              host +
              tempStr +
              (env === "prod" || env === "gray" ? "/index.html" : "/") +
              "#/xmx_group_pay?userOpenId=" +
              this.openId +
              "&broadcastId=" +
              getUrlParam("broadcastId") +
              (getUrlParam("promoterId")
                ? "&promoterId=" + getUrlParam("promoterId")
                : "") +
              (getUrlParam("referralId")
                ? "&referralId=" + getUrlParam("referralId")
                : "") +
              (this.urlUid ? "&parentUid=" + this.urlUid : "");

            const url: string =
              (CONFIG.shareUrl as any)[env] +
              payAppId +
              "&redirect_uri=" +
              encodeURIComponent(targetUrl) +
              (targetUrl.indexOf("?") != -1 ? "%26" : "%3F") +
              "appid%3D" +
              payAppId +
              "&response_type=code&scope=snsapi_base&state=state#wechat_redirect";
            location.href = url;
          });
        }
      } else {
        // 已报名,跳转到小程序支付结结果页面
        if (window.__wxjs_environment === "miniprogram") {
          const broadcastId = getUrlParam("broadcastId");
          let qrCodeUrl = this.qrCodeUrl;
          if (env === "gray") {
            qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
          }
          const scene = `openId=${
            this.openId
          }&activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(
            qrCodeUrl
          )}`;
          window.wx.miniProgram.redirectTo({
            url: `/pages/pay-result/index?${scene}`
          });
        } else {
          const targetUrl: string =
            "https://" +
            host +
            tempStr +
            (env === "prod" || env === "gray" ? "/index.html" : "/") +
            "#/xmx_group_pay_result?userOpenId=" +
            this.openId +
            "&broadcastId=" +
            getUrlParam("broadcastId");
          location.href = targetUrl;
        }
      }
    } else {
      Vue.$modal({
        ok: (
          name: string,
          phone: string,
          authCode: string,
          additionalInfo: string,
          instId?: string,
          seqNo?:number
        ) => {
          this.openGroup(name, phone, authCode, additionalInfo, instId, seqNo);
        }
      });
    }

    try {
      // 链接上有uid为二级页面，没有则为一级页面
      // 统计一级活动页报名数
      if (!getUrlParam("uid")) {
        window.TDAPP.onEvent("一级活动页报名数", "团购");
      } else {
        // 统计二级页面浏览数
        window.TDAPP.onEvent("二级活动页报名数", "团购");
      }
    } catch (error) {
      throw new Error(error);
    }
  }

  // 开团
  openGroup(
    name: string,
    phone: string,
    authCode: string,
    additionalInfo: string,
    instId?: string,
    seqNo?:number
  ) {
    if (this.orgId && !instId) {
      Vue.$toast.error('请选择校区');
      return null;
    }
    const data = {
      name,
      instId,
      phone,
      authCode,
      additionalInfo,
      openId: this.openId,
      activityId: getUrlParam("broadcastId")
    };
    const promoterId: string = getUrlParam("promoterId") as string;
    const referralId: string = getUrlParam("referralId") as string;
    if (promoterId) {
      (data as any).promoterId = promoterId;
    }
    if (referralId) {
      (data as any).referralId = referralId;
    }
    (data as any).seqNo = seqNo || 1;

    console.log('开团-data', data);
    
    fetch
      .newpost("anon/group/joinActivity", data)
      .then((res: AxiosPromiseData) => {
        this.show = false;
        const { result } = res;

        Vue.$confirm({
          title: "提示",
          text: "您已成功报名，<br />快去找好友一起拼团吧！",
          cancleText: "我知道了",
          okText: "找好友一起拼",
          cancle: () => {
            this.changeUid({ uid: result });
            this.changeJoinNumber(this.joinNumber + 1);
            const location =
              window.location.href
                .replace(/[?, &]code.*state/i, "")
                .replace(/&uid=\d*/, "") +
              "&uid=" +
              result;
            this.changeUrlUid(result);
            this.signatureWechatShare(location);
            exchangeMsgToXcx(result);
          },
          ok: () => {
            this.changeUid({ uid: result });
            this.changeJoinNumber(this.joinNumber + 1);
            const location =
              window.location.href
                .replace(/[?, &]code.*state/i, "")
                .replace(/&uid=\d*/, "") +
              "&uid=" +
              result;
            this.changeUrlUid(result);
            this.handleRedirectToSharePage(result);
            this.signatureWechatShare(location);
            exchangeMsgToXcx(result);
          }
        });
      })
      .catch((error: AxiosPromiseError) => {
        if (error.resultCode === 1402) {
          this.show = false;
          Vue.$confirm({
            oneBtn: true,
            title: "很抱歉",
            text: "活动已结束",
            okText: "确定"
          });
        }
        if (error.resultCode === 1519) {
          this.show = false;
          Vue.$confirm({
            oneBtn: true,
            title: "很抱歉",
            text: `该活动已达到${
              this.canPay ? "支付人数" : "成团数"
            }上限，<br />无法继续开团/参团！`,
            okText: "确定"
          });
        }
      });
  }

  // 参团
  joinOtherGroup(
    name: string,
    phone: string,
    authCode: string,
    additionalInfo: string,
    instId?: string,
  ) {
    if (this.orgId && !instId) {
      Vue.$toast.error('请选择校区');
      return null;
    }
    const data = {
      name,
      instId,
      phone,
      authCode,
      additionalInfo,
      openId: this.openId,
      activityId: getUrlParam("broadcastId"),
      leaderId: this.originatorId
    };
    const promoterId: string = getUrlParam("promoterId") as string;
    const referralId: string = getUrlParam("referralId") as string;
    if (promoterId) {
      (data as any).promoterId = promoterId;
    }
    if (referralId) {
      (data as any).referralId = referralId;
    }
    fetch
      .newpost("anon/group/joinActivity", data)
      .then((res: AxiosPromiseData) => {
        this.showJoin = false;
        this.changeJoinGroupFlag(true);
        this.changeUrlUid("");

        const { result } = res;
        Vue.$confirm({
          title: "提示",
          text: "您已成功报名，<br />快去找好友一起拼团吧！",
          cancleText: "我知道了",
          okText: "找好友一起拼",
          cancle: () => {
            this.changeUid({ uid: result });
            this.changeJoinNumber(this.joinNumber + 1);
            // 通过这个团员去获取团长的UID
            const param = {
              activityId: getUrlParam("broadcastId"),
              userId: result
            };
            fetch
              .newpost("anon/group/getCurrentGroup", param)
              .then((res: AxiosPromiseData) => {
                const { result } = res;
                const {
                  groupDetailVOS,
                  groupSize,
                  applyNum,
                  maxGroupSize
                } = result;

                const userId: string = groupDetailVOS[0].userId;
                const location =
                  window.location.href
                    .replace(/[?, &]code.*state/i, "")
                    .replace(/&uid=\d*/, "") +
                  "&uid=" +
                  userId;
                this.changeUrlUid(userId);
                this.signatureWechatShare(location);
                exchangeMsgToXcx(userId);
              });
          },
          ok: () => {
            this.changeUid({ uid: result });
            this.changeJoinNumber(this.joinNumber + 1);
            const param = {
              activityId: getUrlParam("broadcastId"),
              userId: result
            };
            fetch
              .newpost("anon/group/getCurrentGroup", param)
              .then((res: AxiosPromiseData) => {
                const { result } = res;
                const {
                  groupDetailVOS,
                  groupSize,
                  applyNum,
                  maxGroupSize
                } = result;
                const userId: string = groupDetailVOS[0].userId;

                const location =
                  window.location.href
                    .replace(/[?, &]code.*state/i, "")
                    .replace(/&uid=\d*/, "") +
                  "&uid=" +
                  userId;
                this.changeUrlUid(userId);
                this.handleRedirectToSharePage(this.originatorId);
                this.signatureWechatShare(location);
                exchangeMsgToXcx(userId);
              });
          }
        });
      })
      .catch((error: AxiosPromiseError) => {
        if (!error.success) {
          Vue.$toast.error(error.resultMsg || error.message);
        }
        if (error.resultCode === 1402) {
          this.showJoin = false;
          Vue.$confirm({
            oneBtn: true,
            title: "很抱歉",
            text: "活动已结束",
            okText: "确定"
          });
        }
        if (error.resultCode === 1519) {
          this.showJoin = false;
          Vue.$confirm({
            oneBtn: true,
            title: "很抱歉",
            text: `该活动已达到${
              this.canPay ? "支付人数" : "成团"
            }上限，<br />无法继续开团/参团！`,
            okText: "确定"
          });
        }
        if (error.resultCode === 1520) {
          this.showJoin = false;
          Vue.$confirm({
            title: "很抱歉",
            text: "老生无法参团，只能开团",
            cancleText: "我知道了",
            okText: "去开团",
            ok: () => {
              this.openGroup(name, phone, authCode, additionalInfo);
            }
          });
        }
      });
  }
  // 查看我的报名记录
  handleViewMyRecord() {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const host: string = location.host;
    const tempStr: string = env === "gray" ? "/xmpay" : "/xmpay";
    // 已报名,跳转到小程序支付结结果页面
    if (window.__wxjs_environment === "miniprogram") {
      const broadcastId = getUrlParam("broadcastId");
      let qrCodeUrl = this.qrCodeUrl;
      if (env === "gray") {
        qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
      }
      const scene = `openId=${
        this.openId
      }&activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}`;
      window.wx.miniProgram.navigateTo({
        url: `/pages/pay-result/index?${scene}`
      });
    } else {
      const targetUrl: string =
        "https://" +
        host +
        tempStr +
        (env === "prod" || env === "gray" ? "/index.html" : "/") +
        "#/xmx_group_pay_result?userOpenId=" +
        this.openId +
        "&broadcastId=" +
        getUrlParam("broadcastId");
      location.href = targetUrl;
    }
  }

  // 查看我的拼团
  handleToMyGroup() {
    const location =
      window.location.href
        .replace(/[?,&]code.*state/i, "")
        .replace(/&uid=\d*/, "") +
      "&uid=" +
      this.uid;
    this.signatureWechatShare(location);
    exchangeMsgToXcx(this.uid);
    this.changeUrlUid(this.uid);
  }

  signatureWechatShare(location: string) {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const shareUrl: string =
      (CONFIG.shareUrl as any)[env] +
      (CONFIG.appId as any)[env] +
      "&redirect_uri=" +
      encodeURIComponent(location) +
      "&response_type=code&scope=snsapi_base&state=state#wechat_redirect";
    const shareObject: ShareObjectInterface = {
      title: this.title.replace(/<br\/>/g, "\n"),
      desc: pickHtmlTextContent(this.section.courseDesc),
      link: shareUrl,
      imgUrl: this.coverTiny
    };
    this.changePosterUrl(shareUrl);
    wechatSignUp(this.signature, shareObject);
  }

  // 显示/隐藏分享popup
  handleRedirectToSharePage(parentUid: string) {
    // 跳转到小程序分享页面
    const broadcastId = getUrlParam("broadcastId");
    const posterName = this.posterName;
    const origin = getUrlParam("origin");
    // 团购分享出去的链接需要带上团长id
    // 如果是从独立版小麦秀小程序进入的分享页,那么分享的时候就跳到独立版小麦秀的分享页
    if (origin === "ordinary") {
      window.wx.miniProgram.redirectTo({
        url: `/pages/activity/activityShare/main?id=${broadcastId}&parentUid=${parentUid}`
      });
    } else {
      window.wx.miniProgram.navigateTo({
        url: `/pages/user-share/index?broadcastId=${broadcastId}&parentUid=${parentUid}&name=${posterName}`
      });
    }
  }
}
